import { makeStyles } from "tss-react/mui";

import { alpha } from "@mui/material";

const additionalPadding = 150;

export const useStyles = makeStyles()((theme) => ({
    box: {
        display: "flex",
        justifyContent: "flex-end",
        width: "100%",
        gap: theme.spacing(1),
    },
    paneBox: {
        position: "absolute",
        top: 0,
        height: `calc(100vh - ${additionalPadding}px)`,
        marginTop: theme.spacing(30),
        width: "70%",
        right: 0,
        overflow: "auto",
        zIndex: 10,
    },
    tableCell: {
        cursor: "pointer",
        whiteSpace: "nowrap",
        overflow: "hidden",
        textOverflow: "ellipsis",
    },
    sortIcon: {
        position: "relative",
        top: theme.spacing(1),
    },
    sortingIconContainer: {
        fontWeight: 600,
        display: "flex",
    },
    searchContainer: {
        position: "relative",
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        marginBottom: theme.spacing(2),
        gap: theme.spacing(2),
    },
    searchContainerWithDropStrip: {
        minHeight: 80,
    },
    topLevelDropTable: {
        borderColor: theme.palette.emteria.primary,
        backgroundImage: `linear-gradient(${alpha(theme.palette.emteria.primary, 0.08)}, ${alpha(theme.palette.emteria.primary, 0.08)})`,
    },
}));
